/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnimalContractDetails
 */
export interface AnimalContractDetails {
    /**
     * 
     * @type {string}
     * @memberof AnimalContractDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AnimalContractDetails
     */
    speciesCode: string;
    /**
     * 
     * @type {string}
     * @memberof AnimalContractDetails
     */
    breedCode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AnimalContractDetails
     */
    birthDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AnimalContractDetails
     */
    isIdentified: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnimalContractDetails
     */
    identificationNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnimalContractDetails
     */
    vaccinesUpToDate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnimalContractDetails
     */
    isProfessionalUse: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnimalContractDetails
     */
    isDogCategory1Or2: boolean;
}

/**
 * Check if a given object implements the AnimalContractDetails interface.
 */
export function instanceOfAnimalContractDetails(value: object): value is AnimalContractDetails {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('speciesCode' in value) || value['speciesCode'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('isIdentified' in value) || value['isIdentified'] === undefined) return false;
    if (!('vaccinesUpToDate' in value) || value['vaccinesUpToDate'] === undefined) return false;
    if (!('isProfessionalUse' in value) || value['isProfessionalUse'] === undefined) return false;
    if (!('isDogCategory1Or2' in value) || value['isDogCategory1Or2'] === undefined) return false;
    return true;
}

export function AnimalContractDetailsFromJSON(json: any): AnimalContractDetails {
    return AnimalContractDetailsFromJSONTyped(json, false);
}

export function AnimalContractDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnimalContractDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'speciesCode': json['speciesCode'],
        'breedCode': json['breedCode'] == null ? undefined : json['breedCode'],
        'birthDate': (new Date(json['birthDate'])),
        'isIdentified': json['isIdentified'],
        'identificationNumber': json['identificationNumber'] == null ? undefined : json['identificationNumber'],
        'vaccinesUpToDate': json['vaccinesUpToDate'],
        'isProfessionalUse': json['isProfessionalUse'],
        'isDogCategory1Or2': json['isDogCategory1Or2'],
    };
}

export function AnimalContractDetailsToJSON(json: any): AnimalContractDetails {
    return AnimalContractDetailsToJSONTyped(json, false);
}

export function AnimalContractDetailsToJSONTyped(value?: AnimalContractDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'speciesCode': value['speciesCode'],
        'breedCode': value['breedCode'],
        'birthDate': ((value['birthDate']).toISOString()),
        'isIdentified': value['isIdentified'],
        'identificationNumber': value['identificationNumber'],
        'vaccinesUpToDate': value['vaccinesUpToDate'],
        'isProfessionalUse': value['isProfessionalUse'],
        'isDogCategory1Or2': value['isDogCategory1Or2'],
    };
}

